import Status from "./status";

export default class Response {
  payload: any | null;
  status: Status;

  constructor() {
    this.payload = null;
    this.status = new Status();
  }

  static fromJSON(json: Record<string, any>): Response {
    const resp = new Response();

    if (json.payload) {
      resp.payload = json.payload;
    }

    if (json.status) {
      resp.status = Status.fromJSON(json.status);
    }

    return resp;
  }
}
